import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable */

// TODO: https://product-fabric.atlassian.net/browse/DSP-4290
import { css } from '@emotion/react';
import { N40A, N50A, N60A } from '@atlaskit/theme/colors';
export var searchMatchClass = 'search-match';
export var selectedSearchMatchClass = 'selected-search-match';
export var findReplaceStyles = css(_defineProperty(_defineProperty({}, ".".concat(searchMatchClass), {
  borderRadius: '3px',
  backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
  boxShadow: "var(--ds-shadow-raised, ".concat("0 1px 1px 0 ".concat(N50A, ", 0 0 1px 0 ").concat(N60A), ")") + ', inset 0 0 0 1px ' + "var(--ds-border-input, ".concat("".concat(N40A), ")")
}), ".".concat(selectedSearchMatchClass), {
  backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
}));